import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="footer">
      <Link to="/privacy-policy">Privacy Policy</Link>
    </div>
  );
};

export default Footer;
